import React from "react";
import Button from "components/button/Button";
import useManualQRIS from "./hooks/useManualQRIS";
import DropzoneFile from "components/dropzone";
import { useForm } from "react-hook-form";

const ManualQRIS = () => {
  const { handleSubmit } = useForm();
  const {
    getManualQRISData,
    QRISImageUrl,
    images,
    dropFile,
    removeFile,
    arrangeFiles,
    changeFile,
    handleUpdate,
  } = useManualQRIS();

  React.useEffect(() => {
    getManualQRISData();

    // eslint-disable-next-line
  }, []);

  return (
    <div className="mt-5 h-full">
      <form encType="multipart/form-data" onSubmit={handleSubmit(handleUpdate)}>
        <section className={`mb-3 grid h-fit grid-cols-2`}>
          {QRISImageUrl !== "" ? (
            <section className="flex h-fit w-full flex-col items-center justify-center gap-2">
              <label className="label !text-xl">QRIS saat ini</label>
              <img
                src={`${process.env.REACT_APP_PUBLIC_URL}/${QRISImageUrl}`}
                alt="QRIS"
                className="h-full w-80 rounded-xl object-cover object-center"
              />
            </section>
          ) : null}
          <section className="flex h-fit flex-col items-center">
            <label className="label !text-xl">QRIS baru</label>
            <div className="mt-3 flex h-full w-full flex-col gap-3">
              <DropzoneFile
                text="Upload QRIS"
                accept={{
                  "image/*": [".jpg", ".png", ".jpeg"],
                }}
                maxSize={2048000}
                maxFiles={1}
                files={images}
                dropFile={(files: File[]) => dropFile(files)}
                removeFile={(files: File[]) => removeFile(files)}
                arrangeFiles={(files: File[]) => arrangeFiles(files)}
                changeFile={(files: File[]) => changeFile(files)}
              />
              <Button
                variant="primary"
                children="Simpan"
                size="full"
                type="submit"
                isLoading={false}
              />
            </div>
          </section>
        </section>
      </form>
    </div>
  );
};

export default ManualQRIS;
